import { h } from 'preact';

import { CMS_MANAGED_THUNDR_PAGES, getPages } from 'components/editor/movies/utils';
import MovieHeaderEditor from 'components/editor/movies/movieHeader/movieHeader';

import s from 'components/editor/movies/movieHeader/movieHeaderUniversal.sss';

export default class UniversalMovieHeaderEditor extends MovieHeaderEditor {
	s = s;

	getDefaultLinks() {
		const thundrPages = this.state.thundrData?.pages || {};

		// Map CMS defaults
		const defaultPages = Object.fromEntries(
			getPages(this.props.data).map((page, i) => [
				page.id,
				{
					...page,
					name: this.text(thundrPages[page.destination]?.name || page.name),
					order: i,
					default: true,
					permanent: page.id === 'home',
				},
			])
		);

		// Add any additional Bolt pages that aren't in the CMS defaults
		Object.entries(thundrPages)
			.filter(([thundrId, pageData]) => pageData.base === 'bolt' && !CMS_MANAGED_THUNDR_PAGES.includes(thundrId))
			.forEach(([thundrId, pageData]) => {
				const name = this.text(pageData.name || thundrId);
				const destination = thundrId;
				const order = Object.keys(defaultPages).length;

				defaultPages[thundrId] = { id: thundrId, name, destination, order, permanent: false, default: true };
			});

		return defaultPages;
	}

	renderLogo() {
		return <img src={`${__IMAGE_ROOT__}/logo.svg`} width="79" height="40" alt="Universal Pictures" fetchpriority="high" />;
	}
}